export enum PropertyDisplayType {
  None = 'None',
  Hidden = 'Hidden',
  AddressSelector = 'AddressSelector',
  IconRadio = 'IconRadio',
  IconCheckbox = 'IconCheckbox',
  IconQuantity = 'IconQuantity',
  DatePicker = 'DatePicker'
}
